export const SETTINGS_CURRENT_VERSION = 2;
